import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { bgLinearGradient } from "@/app/types/ui";
import { LanguageSelector } from "@/components/shared/LanguageSelector";
import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { RegistrationEmailForm } from "@/components/register/selfService/RegistrationEmailForm";

import loginImg from "@/assets/login/login-img.png";

export const Route = createFileRoute("/register/")({
  component: SelfServiceRegistration,
});

function SelfServiceRegistration() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 min-h-screen">
      <div className="hidden lg:grid lg:col-span-2 bg-beige self-center">
        <img src={loginImg} alt="" />
      </div>

      <div
        className={`lg:col-span-3 ${bgLinearGradient} h-screen overflow-y-auto`}
      >
        <div className="flex justify-end px-8 pt-8">
          <LanguageSelector />
        </div>

        <div className="max-w-xl mx-auto px-8 py-12">
          <div className="mb-10 flex justify-center">
            <MimiatHorizontalLogo />
          </div>

          <div className="flex flex-col gap-3 mb-8">
            <HeadingOne>
              {t("selfServiceRegistration.title", {
                defaultValue: "Create your clinician account",
              })}
            </HeadingOne>
            <Paragraph>
              {t("selfServiceRegistration.subtitle", {
                defaultValue: "Start by verifying your email address.",
              })}
            </Paragraph>
          </div>

          <RegistrationEmailForm />

          <div className="mt-8 text-center text-sm">
            <Link to="/login" className="text-red hover:underline">
              {t("login.btn_submit")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
